/**
 * Adds a series of strings that users may try typing to fill in a required field.
 * If any of these keywords are hit, the value is invalid.
 *
 * @param context
 * @returns {boolean} - Returns true if the value does not contain any banned keywords, false otherwise.
 */
export default function ReqAllowedStr (context) {
	const bannedKeywords = [
		'tba', 'atba', 'unknown', 'idk', 'na', 'null', 'none', 'n.a.',
		'tbd', 'to be decided', 'to be announced', 'unavailable', 'not applicable',
		'pending', 'undecided', 'undefined', 'not set', 'unset', 'not known',
		'unk', 'nk', 'no comment', 'decline to state', 'blank', 'void',
		'omit', 'omitted', 'not specified', 'unspecified', 'to be confirmed', 'tbc',
		'to be determined', 'not determined', 'not provided', 'np', 'no info',
		'no information', 'info unavailable', 'data unavailable', 'question skipped',
		'skipped', 'missing', 'not entered', 'not answered', 'nae', 'to be filled',
		'to be completed', 'awaiting info', 'awaiting information'
	]

	let value = context.value.trim().toLowerCase()
	value = value.replace(/[^a-z0-9 ]/g, '').replace(/\s+/g, ' ')

	return !bannedKeywords.includes(value)
}
